/**
 * A mapping of monaco web worker labels to worker factories
 */
const WORKER_MAP = {
  editorWorkerService: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/editor/editor.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
  css: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/language/css/css.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
  html: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/language/html/html.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
  json: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/language/json/json.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
  typescript: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/language/typescript/ts.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
  javascript: () =>
    new Worker(
      new URL(
        'npm:monaco-editor/esm/vs/language/typescript/ts.worker.js',
        import.meta.url
      ),
      { type: 'module' }
    ),
};

export default function getMonacoWorker(label: string): Worker {
  if (!isWorkerKey(label)) {
    throw new Error(`Unknown monaco worker ${label}`);
  }
  const getWorker: (() => Worker) | void = WORKER_MAP[label];

  return getWorker();
}

const workerKeys = Object.keys(WORKER_MAP);
function isWorkerKey(key: string): key is keyof typeof WORKER_MAP {
  return workerKeys.includes(key);
}
